import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmRefresh = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-llm-refresh" data-icon="icon-llm-refresh" aria-hidden="true" {...props} ref={ref}><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>);
});

IconLlmRefresh.displayName = 'IconLlmRefresh';
